




















































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import Context from "@/mixins/context";

// Enums
import { DataModules } from "@/store/modules/data";

// Types
import { IAddress } from "@/models/addresses";
import { IState } from "@/store";
import { IClient } from "@/models/clients";

@Component({
  computed: {
    ...mapState({
      clientAddresses(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: this.dataModule,
          scope: this.dataScope
        });
      },
      dataScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/clientScope`](this.clientId);
      }
    })
  }
})
export default class ClientAddressSelect extends Mixins(
  RequestPromises,
  Context
) {
  // Getters
  public clientAddresses!: IAddress[];
  public dataScope!: string;

  @Prop({ required: true })
  public value;

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: "address_id" })
  public selectType!: string;

  @Prop({ default: false })
  public preselectFirst!: boolean;

  @Prop({ default: "required" })
  public rules!: string;

  public dataModule: string = DataModules.CLIENTS_ADDRESSES;

  public isLoading = true;
  public preSelected: string | number = "";

  public async created() {
    try {
      await this.getClientAddresses();

      if (!this.value && this.preselectFirst) {
        this.selectFirstAddress();
      }
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }

    this.isLoading = false;
  }

  public selectFirstAddress() {
    if (!this.clientAddresses.length) return;
    this.selected = this.$_.head(this.clientAddresses)?.id;
  }

  public getClientAddresses(ignoreStored = false) {
    return this.$store.dispatch(`data/${this.dataModule}/list`, {
      id: this.clientId,
      params: {
        limit: 0,
        offset: 0,
        order: "-created_at"
      },
      scope: this.dataScope,
      ignoreStored,
      vm: this
    });
  }

  public get selected() {
    return this.value;
  }

  public set selected(selected) {
    this.$emit("input", selected);
  }

  public async onAddressChange(value: any) {
    if (value !== "new") {
      return;
    }
    this.isLoading = true;
    this.preSelected = this.selected;
    this.$nextTick(() => {
      this.selected = this.preSelected;
    });
    const modal = await this.$store.dispatch("ui/open/modal", {
      config: {
        component: () =>
          import(
            "@/components/app/global/client/addEditClientAddressModal.vue"
          ),
        props: {
          clientId: this.clientId
        },
        width: 640,
        onCancel: () => {
          this.isLoading = false;
        },
        events: {
          success: async (address: IAddress) => {
            await this.getClientAddresses(true);
            this.selected = address.id;
            this.isLoading = false;
            modal.close();
          }
        }
      }
    });
  }

  public get label() {
    return `${this.$t("_.address")}${
      this.rules.includes("required") ? "*" : ""
    }`;
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: this.dataModule,
      scope: this.dataScope,
      vm: this
    });
  }
}
